import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from "../utils/constants";

export const apiAuth = {
  resetPassword: (value) => AxiosInterceptor().post(API_BASE + "/update-password", value),
  getAdminDetails: (value) => AxiosInterceptor().get(API_BASE + "/auth/profile", value),
  updateAdminProfile: (value) => AxiosInterceptor().put(API_BASE + "/auth/profile", value),
  changePassword: (value) => AxiosInterceptor().put(API_BASE + "/auth/change-password", value),
  // getSetting: (value) => AxiosInterceptor().get(API_BASE + "/setting/get-setting", value),
  // updateSetting: (value) => AxiosInterceptor().post(API_BASE + "/setting/update-setting", value),
  login: (value) => AxiosInterceptor().post(API_BASE + "/auth/login", value),
};

export default apiAuth;
